import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import service from '@/service';
import { selectCurrentServingOrder } from '@/store/service';
import { MassageControlValueContext } from '@/pages/service/massage-control';
import { RF_TECH_SOLUTION_TO_STATIC_SOLUTION } from '@/pages/service/massage-setting/utils';
import When from '@/components/When';
import { SHOCKWAVE_SOLUTION_TO_COORDS } from './utils';

import cx from './index.module.scss';

interface Props {
  shockHitedTargetId: string;
}

const PlainLabel: React.FC<Props> = ({ shockHitedTargetId }) => {
  const currentServingOrder = useSelector(selectCurrentServingOrder);
  const { currentMassageType, currentStepText } = useContext(MassageControlValueContext);
  const [productInfo, setProductInfo] = useState<GetProductResponse>(null);

  const modelSolution = useMemo(() => currentServingOrder?.modelConfig?.[0]?.value, [currentServingOrder?.modelConfig]);
  const currentMassageItem = useMemo(
    () => currentServingOrder?.modelConfig?.[0]?.key,
    [currentServingOrder?.modelConfig]
  );

  const shockPlainLabelStyle = useMemo(
    () =>
      currentServingOrder?.productItems?.[0] === 'Shockwave' && shockHitedTargetId
        ? SHOCKWAVE_SOLUTION_TO_COORDS[modelSolution]?.[shockHitedTargetId]?.coord
        : {},
    [currentServingOrder?.productItems, modelSolution, shockHitedTargetId]
  );

  const titleText = useMemo(
    () =>
      currentMassageItem === 'Shockwave'
        ? productInfo?.effectDesc?.[+shockHitedTargetId - 1]?.name?.replace('->', '到')?.replace(/\s+/g, '')
        : '',
    [currentMassageItem, productInfo?.effectDesc, shockHitedTargetId]
  );

  const effectDescText = useMemo(
    () =>
      currentMassageItem === 'Shockwave'
        ? productInfo?.effectDesc?.[+shockHitedTargetId - 1]?.intro
        : ['RadioFrequency', 'HotStone'].includes(currentMassageItem)
        ? productInfo?.effectDesc?.[0]?.intro
        : '',
    [currentMassageItem, productInfo, shockHitedTargetId]
  );

  // eslint-disable-next-line fuxi/require-useEffect-before-return
  useEffect(() => {
    if (currentServingOrder?.storeGoodsId) {
      service.service.getProduct(currentServingOrder.storeGoodsId).then(data => {
        setProductInfo(data?.data || null);
      });
    }
  }, [currentServingOrder.storeGoodsId]);

  // 仅冲击波、射频和热砭石的机器治疗阶段展示功效文本
  if (!['Shockwave', 'RadioFrequency', 'HotStone'].includes(currentMassageItem)) {
    return null;
  }

  // 在按摩中且非机器治疗阶段或者无功效文本介绍，不展示功效文本区块
  if (currentMassageType !== 'Massage' || !effectDescText) {
    return null;
  }

  return (
    <div
      className={cx('PlainLabel', RF_TECH_SOLUTION_TO_STATIC_SOLUTION[modelSolution] || modelSolution, {
        'left-arrow':
          (currentServingOrder?.productItems?.[0] === 'Shockwave' && titleText?.includes('右')) ||
          currentStepText?.includes('右'),
      })}
      style={shockPlainLabelStyle}
    >
      <When condition={!!titleText}>
        <div className={cx('title')}>{titleText}</div>
      </When>
      <div className={cx('info-text')}>
        <div>{effectDescText}</div>
      </div>
    </div>
  );
};

export default PlainLabel;
